import React from "react";

import { LanguageIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import { TwListBox } from "./tailwind";
// import "node_modules/flag-icons/css/flag-icons.min.css";
import "/node_modules/flag-icons/css/flag-icons.min.css";

export const i18nextLangs = [
  { value: "en-US", title: (<div className="flex gap-2"><span className={`fi fi-gb`} /> EN</div>) },
  { value: "nl", title: (<div className="flex gap-2"> <span className={`fi fi-nl`} /> NL</div>) },
  // { value: "en-US", title: (<>EN</>) },
  // { value: "nl", title: (<> NL</>) },
]

export default function I18nLanguageDropdown(props) {
  const { imageClassName } = props

  const { t, i18n } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = React.useState('nl');


  React.useEffect(() => {
    if (i18n.resolvedLanguage) {
      setSelectedLanguage(i18n.resolvedLanguage)
    }
  }, [i18n.resolvedLanguage]);
  return (
    <TwListBox
      value={selectedLanguage}
      options={i18nextLangs}
      // dropdownArrow={(<LanguageIcon aria-hidden="true" className="size-5 text-black forced-colors:text-[Highlight]" />)}
      onChange={(v) => {
        // setSelectedLanguage(v.value);
        i18n.changeLanguage(v.value)
      }}
    />
  );
}
